import FeatureGate from '../../FeatureGate';
import CurrencySettings from './CurrencySettings';
import StripeIntegration from './StripeIntegration';
import SquareIntegration from './SquareIntegration';
import TStrings from './Payment.i18n';
import { useState } from 'react';
import { PaymentProcessor } from './Payment.types';
import FlowBuilder from '~/components/flows/FlowBuilder';
import { useFlowQuery } from '~/lib/Queries';
import { getBusinessId } from '~/lib/Api';

const PaymentAutomations = () => {
    const flowableType = 'paymentbusiness';
    const flowableId = getBusinessId();

    return (
        <div className="mt-4 max-w-2xl">
            <div className="panel-label mt-4">
                {TStrings.AUTOMATIONS_TITLE}
            </div>
            <FlowBuilder flowableId={flowableId} flowableType={flowableType} className="mt-2" />
        </div>
    );
};

const PaymentsIntegration = () => {
    const [selectedProcessor, setSelectedProcessor] =
        useState<PaymentProcessor>();
    return (
        <>
            <div className="panel-label">{TStrings.CURRENCY_TITLE}</div>
            <CurrencySettings />

            <div
                className="mt-4 max-w-2xl"
            >
                <div className="panel-label mt-4">
                    {TStrings.PAYMENT_PROCESSOR_TITLE}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
                    <SquareIntegration
                        disabled={selectedProcessor === PaymentProcessor.Stripe}
                        className="flex flex-1 panel px-6 pb-4 mb-6"
                        onIntegrationEnabled={setSelectedProcessor}
                    />
                    <StripeIntegration
                        disabled={selectedProcessor === PaymentProcessor.Square}
                        className="flex flex-1 panel px-6 pb-4 mb-6"
                        onIntegrationEnabled={setSelectedProcessor}
                    />
                </div>
            </div>

            <PaymentAutomations />
        </>
    );
};

export default PaymentsIntegration;
